import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Proveedor } from '../../../models/proveedor';
import { ProveedorService } from '../../../services/proveedor.service';
import { ProveedorModalComponent } from '../../modals/proveedor-modal/proveedor-modal.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Compra } from '../../../models/compra';
import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';
import { CompraService } from '../../../services/compra.service';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { ComprobanteService } from '../../../services/comprobante.service';
import { TipoDocumento } from '../../../models/tipo-documento';

import * as moment from 'moment';
import { Bodega } from '../../../models/bodega';
import { CompraDetalle } from '../../../models/compra_detalle';
import { Validation } from '../../../config/validation';
import { BodegaService } from '../../../services/bodega.service';
import { ServicioModalComponent } from '../../modals/servicio-modal/servicio-modal.component';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { UtilsService } from '../../../services/utils.service';
import { Amortizacion } from '../../../models/amortizacion';

import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { Lote } from '../../../models/lote';
import { EmitirRetencionCompraModalComponent } from '../../modals/emitir-retencion-compra-modal/emitir-retencion-compra-modal.component';
import { ProductoModalComponent } from '../../modals/producto-modal/producto-modal.component';

import { Message } from '../../../config/message';
import { Producto } from '../../../models/producto';

import { ProductoService } from "../../../services/producto.service";
import { FormaPagoService } from '../../../services/forma-pago.service';
import { FormaPago } from '../../../models/forma-pago';

import { ParametroService } from '../../../services/parametro.service';
import * as numeral from 'numeral';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import { Pago } from '../../../models/pago';
import { PagoDetalle } from '../../../models/pago_detalle';

import { AmortizacionDetalle } from '../../../models/amortizacion_detalle';
import { NumberFormatPipe } from '../../../pipes/number-format.pipe';



import * as xml2js from 'xml2js';

import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';

import { VentaDetalle } from '../../../models/venta_detalle';

import { Parser } from 'xml2js';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { Transferencia } from '../../../models/transferencia';


@Component({
    selector: 'app-liquidacion-compra-add',
    templateUrl: './liquidacion-compra-add.component.html',
    styleUrls: ['./liquidacion-compra-add.component.css'],
    providers: [
        ProveedorService,
        CompraService,
        SessionService,
        CajaService,
        TipoComprobanteService,
        ComprobanteService,
        BodegaService,

        CompraService,

        ProductoService,

        FormaPagoService,

        ParametroService,
        NumberFormatPipe,
        ImpuestoPorcentajeService

    ],
})
export class LiquidacionCompraAddComponent implements OnInit {
    public proveedor: Proveedor;
    public compra: Compra;
    public caja: Caja;
    private compra_detalle: CompraDetalle;
    public amortizacion: Amortizacion;
    public msgSweet: SweetMessage;
    public vl: Validation;
    public cajas: Array<Caja>;
    public tipos: Array<TipoDocumento>;
    public bodegas: Array<Bodega>;

    public bodegas_selected: Array<any>;
    public correos: Array<any>;
    public compras: Array<CompraDetalle>;
    public tipocomprobante_id: String;
    public numero_decimales: number;
    public total_pago: number;
    public loading: boolean;
    public is_compra: boolean;
    public validDateFecha: Boolean;
    bsModalRef: BsModalRef;
    public fecha_emision;
    //public datos: [];
    public Mod_FactElec: string;

    public title: String;
    public msg: Message;
    public lote: Lote;
    public codigo: String;
    public cantidad;
    public fecha_elaboracion;
    public fecha_expiracion;
    private myForm: FormGroup;
    private producto: Producto;
    public IVA: number;
    topPrecios: Array<Compra> = [];
    comprasXML: Array<CompraDetalle> = [];
    iva: number;
    validDateEmision: boolean = true;
    validDateCaducidad: boolean = true;
    valid: boolean = false;
    private productos: Array<Producto> = [];
    FormGroup = new Array();
    bsModalRefC: BsModalRef;
    public Identif: string;
    public formasPago: Array<FormaPago>;
    public cambio: number;

    public caja_id: String;
    public pago: Pago;
    //public Mod_FactElec: string;

    public Mod_Inventario: string;
    public cheques: Array<Cheque>;
    public tarjetas: Array<Tarjeta>;
    public valorefectivo: number;

    public if_uso_lote: boolean;

    public file: File;
    public fecha_actual;
    public fecha_MesAnt;
    public detalle: String;

    public format_decimal: String;
    public retencion: boolean;
    public paso: number;
    public parser: Parser;
    public comprobante: any;
    //public correos: Array<any>;
    public permitirBotones: boolean;

    @ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;
    public calculo_decimales: number;
    public modal: boolean;
    public compra_id: String;
    public parametros: Array<any>
    public iva_id : number;
    public iva_vigente:boolean;
    public iva_porcentaje : any;
    public transferencias: Array<Transferencia>;
    


    constructor(
        public proveedorService: ProveedorService,
        public cajaService: CajaService,
        public tipoComprobanteService: TipoComprobanteService,
        public comprobanteService: ComprobanteService,
        public bodegaService: BodegaService,
        private modalService: BsModalService,
        public ss: SessionService,
        public utils: UtilsService,

        private CompraService: CompraService,
        private productoService: ProductoService,
        public fb: FormBuilder,
        public formaPagoService: FormaPagoService,
        private parametroService: ParametroService,
        public numberFormat: NumberFormatPipe,
        public impuestoPorcentajeService: ImpuestoPorcentajeService

    ) {
        this.proveedor = new Proveedor();
        this.compra = new Compra();
        this.caja = new Caja();
        this.amortizacion = new Amortizacion();
        this.msgSweet = new SweetMessage();
        this.vl = new Validation();
        this.loading = false;
        this.cajas = [];
        this.tipos = [];
        this.correos = [];
        this.bodegas = [];
        this.compras = [];
        this.bodegas_selected = [];
        this.is_compra = false;
        this.validDateFecha = false;
        this.tipocomprobante_id = "";
        this.numero_decimales = 2;
        this.total_pago = 0;
        this.fecha_emision = moment(this.fecha_emision);
        this.Mod_FactElec = this.ss.getData("mod_felectronica");
        this.tipos = [];
        //this.datos = [];
        this.title = "Factura compra";
        this.Identif = "";
        this.IVA = 0;
        this.formasPago = [];
        this.cambio = 0;
        this.pago = new Pago();
        this.Mod_FactElec = this.ss.getData("mod_felectronica");
        this.Mod_Inventario = this.ss.getData("mod_inventario");
        this.cheques = [];
        this.tarjetas = [];
        this.compra = new Compra();
        this.valorefectivo = 0;
        this.fecha_actual = moment(this.fecha_actual);
        this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
        this.lote = new Lote();
        this.codigo = "";
        this.cantidad = "";
        this.fecha_elaboracion = moment(this.fecha_elaboracion);
        this.fecha_expiracion = moment(this.fecha_expiracion);
        this.detalle = "";
        this.compra_detalle = new CompraDetalle();
        this.format_decimal = "0,0.00";
        this.calculo_decimales = 2;
        this.modal = false;
        this.retencion = false;
        this.compra_id = "";
        this.paso = 1;
        this.parser = new Parser();
        this.comprobante = [];
        this.permitirBotones = false;
        this.parametros = [];
        this.iva_id = 0;
        this.iva_vigente = false;
        this.iva_porcentaje = 0;
        this.transferencias = [];



    }

    ngOnInit() {

        this.is_compra = true;

        this.msg = new Message();
        this.is_compra = true;
        this.onForm();
        //	this.isValidBotones();
        let p5 = this.getParametros();
        let p6 = this.getParamNumeroDecimales();
        let p7 = this.getIfUsoLote();
        //let p1 = this.getIVA();
        //Inicializar cajas
        let p2 = this.getCajas();
        //Inicializar comprobantes
        let p3 = this.getTiposComprobante();
        //Inicializar bodegas
        let p4 = this.getBodegas();
        let p8 = this.getIVA(129);

        // let p5 = this.getParamDocumentoManual();
        // let p6 = this.getPreciosAdicionales();
        // let p7 = this.getPrecioUnitarioEditable();
        // let p8 = this.getBodegaBySucursal();
        // let p9 = this.getParamNumeroDecimales();
        // let p10 = this.getIfUsoLote();

        this.loading = true;
        // p1,p2,p3,p4,p5,p6,p7,p8,p9,p10
        Promise.all([p2, p3, p4, p5, p6, p7,p8]).then(
            res => this.loading = false,
            err => this.loading = false
        );
    }

    onForm() {
        this.FormGroup["serie"] = { required: true, max: 3, min: 3, valid: false, n: 0 };
        this.FormGroup["punto_emision"] = { required: true, max: 3, min: 3, valid: false, n: 0 };
        this.FormGroup["secuencial"] = { required: true, min: 1, valid: false, n: 0 };
        this.FormGroup["numero_autorizacion"] = { required: true, max: 50, min: 17, valid: false, n: 0 };
        this.FormGroup["compras"] = { required: true, valid: false, n: 0 };
        this.FormGroup["proveedor_id"] = { required: true, valid: false, n: 0 };
        this.FormGroup["bodega_id"] = { required: true, valid: false, n: 0 };
    }

    onIniDate() {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1; //January is 0!
        let dia = "";
        let mes = "";

        var yyyy = today.getFullYear();
        dia = "" + dd;
        mes = "" + mm;
        if (dd < 10) {
            dia = "0" + dd;
        }
        if (mm < 10) {
            mes = "0" + mm;
        }
        let today2 = dia + '/' + mes + '/' + yyyy;
        this.compra.fecha_emision = today2;
    }

    getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.recalcularFactura();
                    this.calcularCuotasCredito();
					resolve();
				},
				err => {
					this.iva_porcentaje = 0;
					this.IVA = 0;
					reject(err);
				}
			);

			
		});
	}


    getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

    getCajas() {
        return new Promise((resolve, reject) => {
            this.cajaService.getAll("?embed=sucursal&sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                res => {
                    this.cajas = res.data;
                    resolve();
                },
                err => {
                    this.cajas = [];
                    reject(err);
                }
            );
        });
    }

    onChangeCaja() {
        if (this.compra.tipo_comprobante_id) {
            this.getNumeroComprobante();
        }
    }

    onChangeComprobante() {
        // this.isPrinted = false;
        // this.guia_remision = false;
        // this.isMail = false;
        // this.compraIdPrinted = "";
        this.getNumeroComprobante();
    }

    getTiposComprobante() {
        return new Promise((resolve, reject) => {

            if (this.Mod_FactElec) {
                this.Identif = "13";
            }
            else {
                this.Identif = "12";
            }

            this.tipoComprobanteService.getAll("?id=" + this.Identif + "&sort=nombre").subscribe(
                res => {
                    this.tipos = res.data;
                    this.compra.tipo_comprobante_id = this.tipos[0].id;
                    resolve();
                },
                err => {
                    this.tipos = [];
                    reject(err);
                }
            );
        });
    }

    getParamNumeroDecimales() {
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for (let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.datosPagos.numero_decimales = this.numero_decimales;
                    this.datosPagos.setFormat();

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal() {
        return this.format_decimal;
    }

    getNumeroDocumento() {
        this.calcularCuotasCredito();
        return this.compra.numero_documento = this.compra.serie + "-" + this.compra.punto_emision + "-" + this.compra.secuencial;

    }

    validTypeMsgModel(campo, model) {

        let length = model.length;
        let temp = this.FormGroup[campo];
        if (temp.required && length == 0) {
            return this.msg.required;
        }
        if (length < temp.min) {
            return this.msg.lengthMin;
        }
        if (length > temp.max) {
            return this.msg.lengthMax;
        }

    }

    onkeyUp(event, campo) {
        if (this.FormGroup[campo].n == 0) {
            if (event.target.value.length > 0) {
                this.FormGroup[campo].n = 1;
            }
        }
    }

    onChangeSelect(event, campo) {
        if (this.FormGroup[campo].n == 0) {
            this.FormGroup[campo].n = 1;
        }
        if (event.target.value.length > 0) {
            this.FormGroup[campo].valid = true;
        }
        else {
            this.FormGroup[campo].valid = false;
        }
    }

    onValidCamp() {
        let i = 0;
        for (i = 0; i < Object.keys(this.FormGroup).length; i++) {
            var item = Object.keys(this.FormGroup)[i];
            if (!this.FormGroup[item]['valid']) {
                this.valid = true;
                return true;
            }
        }
        this.valid = false;
        return false;
    }

    openEmitirRetencionCompraModal() {
        this.modal = true;
        const initialState = { compra_id: this.compra_id, modal: this.modal };
        this.bsModalRef = this.modalService.show(EmitirRetencionCompraModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

        this.bsModalRef.content.cerrarModal.take(1).subscribe((value) => {
            if (value.isSaved) {
                this.retencion = false;
            }
        });
    }

    onMakeNumeroDocumento(campo) {
        if (campo == "serie" || campo == "punto_emision" || campo == "secuencial") {
            this.compra.numero_documento = this.compra.serie + "-" + this.compra.punto_emision + "-" + this.compra.secuencial;
        }
        this.valid = false;
        return false;
    }

    onValidDateEmision() {
        return this.vl.validDate(this.fecha_emision.toString());
    }

    recalcularItem(compra_detalle: CompraDetalle, event?) {

        compra_detalle.subtotal = (compra_detalle.cantidad * compra_detalle.precio_unitario) - compra_detalle.desc_valor;
        compra_detalle.subtotal = this.utils.redondear(compra_detalle.subtotal, this.calculo_decimales);

        compra_detalle.iva = parseFloat(compra_detalle.subtotal.toString()) * parseFloat(this.IVA.toString());
        this.recalcularFactura();
        this.calcularCuotasCredito();
        //this.calcularTotal(this.total_pago);
        // this.calcularFactura();
    }

    onKeyUp(event, compra_detalle: CompraDetalle) {
        compra_detalle.cantidad = event.target.value;
        this.calcularItem(compra_detalle.precio_unitario, compra_detalle);
    }

    onChange(event, compra_detalle: CompraDetalle) {
        compra_detalle.precio_unitario = event.target.value;
        this.calcularItem(compra_detalle.precio_unitario, compra_detalle);
    }

    calcularItem(precio_unitario: number, compra_detalle: CompraDetalle) {
        compra_detalle.precio_unitario = precio_unitario;
        compra_detalle.subtotal = compra_detalle.precio_unitario * compra_detalle.cantidad;
        compra_detalle.iva = compra_detalle.subtotal * this.iva;
        compra_detalle.total = compra_detalle.subtotal + compra_detalle.iva;
        //this.calcularFactura();
    }

    recalcularFactura() {
        this.compra.subtotal_iva12 = 0;
        this.compra.subtotal_iva0 = 0;
        this.compra.iva = 0;
        this.compra.total = 0;

        let tipo_comprobante_id = parseInt(this.compra.tipo_comprobante_id.toString());

        this.compras.forEach(obj => {

            /*if( tipo_comprobante_id === 1 && obj.graba_iva ){
                this.compra.subtotal_iva12 += obj.subtotal;
            }else{
                this.compra.subtotal_iva0 += obj.subtotal;
            }*/


            if ((tipo_comprobante_id === 12 && obj.graba_iva) || tipo_comprobante_id == 13 && obj.graba_iva) {
                this.compra.subtotal_iva12 += obj.subtotal;
                this.compra.subtotal_iva12 = this.utils.redondear(this.compra.subtotal_iva12, this.calculo_decimales);
            } else {
                this.compra.subtotal_iva0 += obj.subtotal;
            }
        });

        if (this.compra.desct_valor.toString().trim().length === 0) {
            this.compra.desct_valor = 0;
        }
        //let desc_valor = parseFloat(this.compra.desct_valor.toString());
        this.compra.subtotal = parseFloat(this.compra.subtotal_iva0.toString()) + parseFloat(this.compra.subtotal_iva12.toString());
        this.compra.subtotal = parseFloat(this.compra.subtotal.toString()) - parseFloat(this.compra.desct_valor.toString());

        this.compra.subtotal = this.utils.redondear(this.compra.subtotal, this.calculo_decimales);

        //this.compra.iva = Math.round((this.compra.subtotal * this.IVA) * 100) / 100;
        //this.compra.iva = Math.round(((this.compra.subtotal_iva12 - this.compra.desct_valor) * this.IVA) * 100) / 100;
        this.compra.iva = this.utils.redondear(((this.compra.subtotal_iva12 - this.compra.desct_valor) * this.IVA), this.calculo_decimales);

        //this.compra.iva = Math.round((this.compra.subtotal * this.IVA) * 100) / 100;
        this.compra.total = this.compra.subtotal + this.compra.iva;
        this.compra.total = this.utils.redondear(this.compra.total, this.calculo_decimales);

        //CALCULAR CAMBIO
        let saldo = this.compra.total - this.compra.abonado;

        if (this.compra.retencion) {
            saldo = saldo - this.compra.retencion.total;
        }

        this.cambio = (this.total_pago > saldo ? (this.total_pago - saldo) : 0);
        //this.cambio = Math.round( this.cambio * 100) / 100;
        this.cambio = this.utils.redondear(this.cambio, this.calculo_decimales);
    }

    setValuePagos() {
        this.pago.detalle = [];
        this.pago.fecha_pago = moment(this.fecha_emision).format("YYYY-MM-DD");
        this.pago.saldo = this.compra.total;
        this.pago.recibido = this.total_pago;
        this.pago.cambio = this.cambio;

        //this.pago.compra_id = this.compra.id;
        this.pago.detalle = [];
        //this.pago.caja_id = this.ss.getData("caja_id");
        this.pago.empresa_id = this.ss.getData("empresa_id");
        this.pago.sucursal_id = this.ss.getData("sucursal_id");
        this.pago.usuario_id = this.ss.getData("usuario_id");

        if (this.valorefectivo > 0) {
            let pago_detalle = new PagoDetalle();
            pago_detalle.valor = this.valorefectivo;
            pago_detalle.forma_pago_id = "1"; // EFECTIVO
            pago_detalle.debito_credito = "D";
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
        }

        this.cheques.forEach(ch => {
            let pago_detalle = new PagoDetalle();

            pago_detalle.fecha_cheque = ch.fecha;
            pago_detalle.numero_cta = ch.cuenta;
            pago_detalle.numero_cheque = ch.numero;
            pago_detalle.banco_id = ch.banco_id;
            pago_detalle.observacion = ch.observacion;

            pago_detalle.valor = ch.valor;
            pago_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
        });

        this.tarjetas.forEach(tr => {
            let pago_detalle = new PagoDetalle();

            pago_detalle.debito_credito = tr.debito_credito;
            pago_detalle.observacion = tr.observacion;
            pago_detalle.tipo_tarjeta_id = tr.tipo_id;
            pago_detalle.valor = tr.valor;
            pago_detalle.plazo = tr.plazo;
            pago_detalle.tiempo = tr.tiempo;
            pago_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
        });

        this.transferencias.forEach(tr => {
			let pago_detalle = new PagoDetalle();

			pago_detalle.fecha_transferencia = tr.fecha;
			pago_detalle.numero_cta = tr.cuenta;
			pago_detalle.numero_comprobante = tr.numero;
			pago_detalle.banco_id = tr.banco_id;
			pago_detalle.observacion = tr.observacion;

			pago_detalle.valor = tr.valor;
			pago_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
			pago_detalle.empresa_id = this.ss.getData("empresa_id");
			pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
			pago_detalle.usuario_id = this.ss.getData("usuario_id");
			this.pago.detalle.push(pago_detalle);
		});
    }

    onSubmit() {
        this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar la compra?").then(
            res => {
                this.setValuePagos();
                // this.setValueEntity();
                this.setValueAmortizacion();
                //this.compra.
                this.compra.caja_id = this.caja.id;
                this.compra.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD")

                this.compra.detalle = this.compras;

                // this.compra.lote = this.compras;
                this.compra.pagos.push(this.pago);
                this.compra.usuario_id = this.ss.getData('usuario_id');
                this.compra.empresa_id = this.ss.getData('empresa_id');
                this.compra.sucursal_id = this.ss.getData('sucursal_id');
                this.compra.proveedor_id = this.proveedor.id;

                let data = {
                    'compra': this.compra,
                };

                if (this.Mod_FactElec) {
                    // if( this.compra.cliente.es_contribuyente ){
                    //     if( this.compra.cliente.num_contribuyente.toString().trim().length === 0 ){
                    //         this.msgSweet.showMessage('error-message', "El proveedor no consta con número de contribuyente");
                    //         return false;
                    //     }
                    // }
                    // if(this.compra.total >= 200 && this.compra.proveedor.id == "1"){
                    //     this.msgSweet.showMessage('error-message', "No puede realizar una compra cuyo monto supere los $200 a Consumidor Final");
                    //     return false;
                    // }

                    this.compra.json_string = this.setCompraElectronica(this.compra);
                }

                this.loading = true;
                this.CompraService.save(this.compra).subscribe(
                    res => {
                        this.compra_id = res.id;

                        this.compra = new Compra();
                        this.proveedor = new Proveedor();
                        this.pago = new Pago();
                        this.correos = [];
                        this.cheques = [];
                        this.tarjetas = [];
                        this.transferencias = [];
                        this.valorefectivo = 0;

                        this.datosPagos.total_cheque = 0;
                        this.datosPagos.total_tarjeta = 0;
						this.datosPagos.total_efectivo = 0;
						this.datosPagos.total_transferencia = 0;
                        //this.correos = [];
                        this.compras = [];
                        this.total_pago = 0;
                        //this.onIniDate();
                        this.amortizacion = new Amortizacion();

                        this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente - CAMBIO: ' + numeral(this.cambio).format("0,0.00"));
                        this.cambio = 0;
                        this.loading = false;
                        this.retencion = true;
                    },
                    err => {
                        this.loading = false;
                        this.msgSweet.showMessage('error-message', err);
                    }
                );
            }
        );
    }

    setCompraElectronica(compra: Compra) {

        let compraElectronica = {};
        compraElectronica['datos'] = {};
        compraElectronica['datos']['infoTributaria'] = {};
        compraElectronica['datos']['infoTributaria']['ambiente'] = "";
        compraElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
        compraElectronica['datos']['infoTributaria']['razonSocial'] = "";
        compraElectronica['datos']['infoTributaria']['nombre_comercial'] = "";
        compraElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');

        compraElectronica['datos']['infoTributaria']['claveAcceso'] = "";
        compraElectronica['datos']['infoTributaria']['codDoc'] = "03"; //Liquidación
        compraElectronica['datos']['infoTributaria']['estab'] = compra.serie;
        compraElectronica['datos']['infoTributaria']['ptoEmi'] = compra.punto_emision;
        compraElectronica['datos']['infoTributaria']['secuencial'] = compra.secuencial.toString().padStart(9, "0");
        compraElectronica['datos']['infoTributaria']['dirMatriz'] = ""; //this.ss.getData('emp_direccion');

        compraElectronica['datos']['infoLiquidacionCompra'] = {};
        compraElectronica['datos']['infoLiquidacionCompra']['fechaEmision'] = moment(compra.fecha_emision).format("DD/MM/YYYY");
        compraElectronica['datos']['infoLiquidacionCompra']['dirEstablecimiento'] = this.ss.getData('sucursal_direccion');
        compraElectronica['datos']['infoLiquidacionCompra']['tipoIdentificacionProveedor'] = this.proveedor.tipoidentificacion.cod_dni;
        compraElectronica['datos']['infoLiquidacionCompra']['razonSocialProveedor'] = this.proveedor.razon_social.toString().replace("&", "Y");
        compraElectronica['datos']['infoLiquidacionCompra']['identificacionProveedor'] = this.proveedor.dni;
        let totalSinImpuestos = 0;
        let totalDescuento = 0;
        this.compra.detalle.forEach(item => {
            //totalSinImpuestos += Math.round(item.subtotal * 100) / 100;
            totalSinImpuestos += this.utils.redondear(item.subtotal, this.calculo_decimales);
            totalDescuento += this.utils.redondear(item.desc_valor, this.calculo_decimales);
        });

        compraElectronica['datos']['infoLiquidacionCompra']['totalSinImpuestos'] = totalSinImpuestos;
        compraElectronica['datos']['infoLiquidacionCompra']['totalDescuento'] = totalDescuento;

        compraElectronica['datos']['infoLiquidacionCompra']['totalConImpuestos'] = [];
        if (compra.subtotal_iva0 > 0) {
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 0;
            //totalConImpuestos['descuentoAdicional'] = (Math.round(compra.desct_valor * 100) / 100);
            //totalConImpuestos['descuentoAdicional'] = this.utils.redondear(compra.desct_valor, this.calculo_decimales);
            //totalConImpuestos['baseImponible'] = (Math.round(compra.subtotal_iva0 * 100) / 100);
            totalConImpuestos['baseImponible'] = this.utils.redondear(compra.subtotal_iva0, this.calculo_decimales);
            totalConImpuestos['tarifa'] = this.utils.redondear(compra.iva, this.calculo_decimales) > 0 ? 12 : 0;
            totalConImpuestos['valor'] = "0.00";

            compraElectronica['datos']['infoLiquidacionCompra']['totalConImpuestos'].push(totalConImpuestos);
        }

        if (compra.subtotal_iva12 > 0) {
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 2;
            //totalConImpuestos['descuentoAdicional'] = (Math.round(compra.desct_valor * 100) / 100);
            // totalConImpuestos['descuentoAdicional'] = this.utils.redondear(compra.desct_valor, this.calculo_decimales);
            //totalConImpuestos['baseImponible'] = (Math.round(compra.subtotal_iva12 * 100) / 100);
            totalConImpuestos['baseImponible'] = this.utils.redondear(compra.subtotal_iva12, this.calculo_decimales);
            //totalConImpuestos['valor'] = (Math.round(compra.iva * 100) / 100);
            totalConImpuestos['tarifa'] = this.utils.redondear(compra.iva, this.calculo_decimales) > 0 ? 12 : 0;
            totalConImpuestos['valor'] = this.utils.redondear(compra.iva, this.calculo_decimales);

            compraElectronica['datos']['infoLiquidacionCompra']['totalConImpuestos'].push(totalConImpuestos);
        }

        //  compraElectronica['datos']['infoLiquidacionCompra']['propina'] = "0.00";
        //compraElectronica['datos']['infoLiquidacionCompra']['importeTotal'] = (Math.round(compra.total * 100) / 100);
        compraElectronica['datos']['infoLiquidacionCompra']['importeTotal'] = this.utils.redondear(compra.total, this.calculo_decimales);
        compraElectronica['datos']['infoLiquidacionCompra']['moneda'] = "DOLAR";

        compraElectronica['datos']['infoLiquidacionCompra']['pagos'] = [];

        if (this.compra.tipo == "CO") {
            //01 => EFECTIVO
            //this.valorefectivo = Math.round(this.valorefectivo * 100) / 100;
            this.valorefectivo = this.utils.redondear(this.valorefectivo, this.calculo_decimales);
            if (this.valorefectivo > 0) {
                let pago = {};
                pago["formaPago"] = "01";
                //pago["total"] = (Math.round((parseFloat(this.valorefectivo.toString()) - parseFloat(this.cambio.toString())) * 100) / 100);
                pago["total"] = this.utils.redondear((parseFloat(this.valorefectivo.toString()) - parseFloat(this.cambio.toString())), this.calculo_decimales);
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                compraElectronica['datos']['infoLiquidacionCompra']['pagos'].push(pago);
            }

            let totalChOtrosCon = 0;
            this.cheques.forEach(ch => {
                totalChOtrosCon += parseFloat(ch.valor.toString());
            });

            //20 => OTROS
            //totalChOtrosCon = Math.round(totalChOtrosCon * 100) / 100;;
            totalChOtrosCon = this.utils.redondear(totalChOtrosCon, this.calculo_decimales);
            if (totalChOtrosCon > 0) {
                let pago = {};
                pago["formaPago"] = "20";
                //pago["total"] = (Math.round(totalChOtrosCon * 100) / 100);
                pago["total"] = this.utils.redondear(totalChOtrosCon, this.calculo_decimales);
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                compraElectronica['datos']['infoLiquidacionCompra']['pagos'].push(pago);
            }

            //16 => DEBITO; 19 => CREDITO
            this.tarjetas.forEach(tr => {
                let pago = {};
                pago["formaPago"] = (tr.debito_credito === "D" ? "16" : "19");
                //tr.valor = Math.round(tr.valor * 100) / 100;;
                tr.valor = this.utils.redondear(tr.valor, this.calculo_decimales);
                //pago["total"] = (Math.round(tr.valor * 100) / 100);
                pago["total"] = this.utils.redondear(tr.valor, this.calculo_decimales);
                pago["plazo"] = tr.plazo;
                pago["unidadTiempo"] = tr.tiempo.toUpperCase();
                compraElectronica['datos']['infoLiquidacionCompra']['pagos'].push(pago);
            });
        } else {
            //20 => OTROS
            let pago = {};
            pago["formaPago"] = "20";
            let valor = parseFloat(compra.total.toString()) - parseFloat(this.cambio.toString())
            //valor = Math.round(valor * 100) / 100;
            //pago["total"] = (Math.round(valor * 100) / 100);
            pago["total"] = this.utils.redondear(valor, this.calculo_decimales);
            pago["plazo"] = "0";
            pago["unidadTiempo"] = "DIAS";
            compraElectronica['datos']['infoLiquidacionCompra']['pagos'].push(pago);
        }

        compraElectronica['datos']['detalles'] = [];
        compra.detalle.forEach((item) => {
            let detalle = {};
            let detalle_item = item.detalle.toString().replace(/\n/g, ", ");

            detalle['codigoPrincipal'] = (item.codigo).replace(/\//g, '-');
            //  detalle['codigoAuxiliar'] = (item.codigo).replace(/\//g,'-');
            detalle['descripcion'] = (item.producto + (item.detalle.length > 0 ? " - " + detalle_item : "")).replace(/\//g, '-');
            detalle['cantidad'] = item.cantidad;
            //detalle['precioUnitario'] = (Math.round(item.precio_unitario * 100) / 100);
            //detalle['precioUnitario'] = this.utils.redondear(item.precio_unitario, this.calculo_decimales);
            detalle['precioUnitario'] = item.precio_unitario;
            //detalle['descuento'] = (Math.round(item.desc_valor * 100) / 100);
            detalle['descuento'] = this.utils.redondear(item.desc_valor, this.calculo_decimales);
            //detalle['precioTotalSinImpuesto'] = (Math.round(item.subtotal * 100) / 100);
            detalle['precioTotalSinImpuesto'] = this.utils.redondear(item.subtotal, this.calculo_decimales);
            detalle['impuestos'] = [];
            let impuesto = {};
            impuesto['codigo'] = 2;
            impuesto['codigoPorcentaje'] = (item.iva > 0 ? 2 : 0);
            impuesto['tarifa'] = (item.iva > 0 ? 12 : 0);
            //impuesto['baseImponible'] = (Math.round(item.subtotal * 100) / 100);
            impuesto['baseImponible'] = this.utils.redondear(item.subtotal, this.calculo_decimales);
            //impuesto['valor'] = Math.round(item.iva * 100) / 100;
            impuesto['valor'] = this.utils.redondear(item.iva, this.calculo_decimales);
            detalle['impuestos'].push(impuesto);
            compraElectronica['datos']['detalles'].push(detalle);
        });

        compraElectronica['datos']['infoAdicional'] = [];
        let adicional = {};
        adicional['Email'] = this.correos.toString(); //this.proveedor.correo;
        adicional['Direccion'] = this.proveedor.direccion.replace(/\//g, '-');

        let telefono = "0999999999";
        if (this.proveedor.telefono.toString().trim().length > 0) {
            telefono = this.proveedor.telefono.toString();
        }
        if (this.proveedor.celular.toString().trim().length > 0) {
            telefono = this.proveedor.celular.toString();
        }
        adicional['Telefono'] = telefono;

        // this.datos.forEach(dato => {
        //     adicional[dato.descripcion.toString()] = dato.valor.toString();
        // });

        compraElectronica['datos']['infoAdicional'].push(adicional);
        return compraElectronica;
    }

    isValidForm() {
        if (!this.proveedor.id) {
            return false;
        }
        if (!this.compra.proveedor) {
            return false;
        }

        // let productos = this.compras.filter((c: CompraDetalle) => c.es_servicio);
        let productos = this.compras.filter((c: CompraDetalle) => c.tipo_producto_id == "2");
        if (!productos.length) {
            if (!this.compra.bodega_id) {
                return false;
            }
        }
        if (!this.compra.serie) {
            return false;
        }
        if (!this.compra.punto_emision) {
            return false;
        }
        if (!this.compra.secuencial) {
            return false;
        }
        if (!this.vl.validDate(this.fecha_emision.toString())) {
            return false;
        }
        /*if( !this.vl.validDate(this.fecha_emision.toString()) ){
            return false;
        }*/
        if (this.fecha_emision.toString().trim().length === 0) {
            return false;
        }
        if (!this.compras.length) {
            return false;
        }
        if (!this.compra.tipo) {
            return false;
        }
        if (this.compra.tipo === "CO") {
            //let total_pago = Math.round(this.total_pago * 100) / 100;
            let total_pago = this.utils.redondear(this.total_pago, this.calculo_decimales);
            //let compra_total = Math.round(this.compra.total * 100) / 100;
            let compra_total = this.utils.redondear(this.compra.total, this.calculo_decimales);

            if (parseFloat(total_pago.toString()) < parseFloat(compra_total.toString())) {
                return false;
            }
        }
        /*else{
            if(!this.isValidFormCuotas()){
                return false;
            }
        }*/

        return true;
    }

    isCheckedCredito() {
        if (this.compra.tipo == "CR") {
            return false;
        }
        return true;
    }

    onDelete(i) {

        this.compras.splice(i, 1);
        this.recalcularFactura();
        this.calcularCuotasCredito();
    }

    calcularTotal(total) {
        this.total_pago = total;

        //CALCULAR CAMBIO
        let saldo = this.compra.total - this.compra.abonado;

        if (this.compra.retencion) {
            saldo = saldo - this.compra.retencion.total;
        }

        this.cambio = (this.total_pago > saldo ? (this.total_pago - saldo) : 0);
        //this.cambio = Math.round( this.cambio * 100) / 100;
        this.cambio = this.utils.redondear(this.cambio, this.calculo_decimales);
        this.calcularCuotasCredito();
    }

    onChangeEfectivo(total) {
        this.calcularCuotasCredito();
        this.valorefectivo = total;
    }

    uploadLogo(event) {
        //this.logo = event.target.files[0];
    }

    openModalCredito(template: TemplateRef<any>) {
        //if(this.compra.tipo == "CR"){
        this.valorefectivo = 0;
        this.cheques = [];
        this.tarjetas = [];
        this.total_pago = 0;
        //}
        this.transferencias = [];
        this.bsModalRef = this.modalService.show(template);
        //this.modalService.onDismiss

    }
        

        //}

    openModalCargaXML(template: TemplateRef<any>) {
        this.paso = 1;
        this.comprasXML = [];
        this.bsModalRefC = this.modalService.show(template, { backdrop: 'static', class: 'modal-xlg' });
    }

    next() {
        this.paso++;
        //	this.isValidBotones();
        this.permitirBotones = false;

        if (this.paso == 2) {
            this.getProveedor();
        }

        if (this.paso == 3) {
            let compras = this.comprasXML.filter((c) => c.producto.nombreEquivalente == "");
            if (!compras.length) {
                this.permitirBotones = true;
            } else
                this.permitirBotones = false;
        }
        if (this.paso == 4) {
            this.bsModalRefC.hide();
            this.comprasXML.forEach(e => {
                e.producto.nombre = e.producto.nombreEquivalente;
            });
            this.compras = this.comprasXML;
            this.compras.forEach(compraDetalle => {
                this.recalcularItem(compraDetalle);
            });
            this.comprasXML = [];
            this.paso = 1;
            this.msgSweet.showMessage('single-message', "Verifique los datos de la factura");
        }
    }

    previous() {
        this.paso--;
        this.permitirBotones = false;
        if (this.paso == 1) {
            this.comprasXML = [];
        }
        if (this.paso == 2) {
            this.permitirBotones = true;
        }
        //	this.isValidBotones();
    }

    addCuota() {
        //let cuota = new Cuota();
        let item = new AmortizacionDetalle();
        this.amortizacion.detalle.push(item);
        //if(this.compra.tipo == "CR"){
        this.valorefectivo = 0;
        this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];

        //}
        this.calcularCuotasCredito();
    }

    calcularCuotasCredito() {
        let saldo_credito = parseFloat(this.compra.total.toString()) - parseFloat(this.total_pago.toString());

        //let valor_cuota = Math.round((saldo_credito / this.amortizacion.detalle.length) * 100) / 100;
        let valor_cuota = this.utils.redondear((saldo_credito / this.amortizacion.detalle.length), this.calculo_decimales);

        let acumulado = 0;


        let now = moment();
        let fecha = moment(now.format(), moment.ISO_8601).format();


        this.amortizacion.detalle.forEach((item, i) => {

            if ((i + 1) === this.amortizacion.detalle.length) {
                item.cuota = saldo_credito - acumulado;
                //item.cuota = Math.round(item.cuota * 100) / 100;
                item.cuota = this.utils.redondear(item.cuota, this.calculo_decimales);


                let now = moment();
                let fecha = moment(now.format(), moment.ISO_8601).add((i + 1), 'month').format();
                item.fecha_vencimiento = fecha;
            } else {
                acumulado += valor_cuota;
                item.cuota = valor_cuota;

                let now = moment();
                let fecha = moment(now.format(), moment.ISO_8601).add((i + 1), 'month').format();
                item.fecha_vencimiento = fecha;
            }

        });
    }

    saldoCuotas() {
        return parseFloat(this.compra.total.toString()) - parseFloat(this.total_pago.toString());
    }


    removeCuota(i) {
        //this.cuotas_credito.splice(i,1);
        this.amortizacion.detalle.splice(i, 1);
        this.calcularCuotasCredito();
    }


    getTotalCuotasCredito() {
        let total = 0;

        this.amortizacion.detalle.forEach(item => {
            total += item.cuota.toString().length === 0 ? 0 : (parseFloat(item.cuota.toString()));
        });

        total = this.utils.redondear(total, this.calculo_decimales);

        return total;
    }


    setValueAmortizacion() {
        this.amortizacion.valor = this.saldoCuotas();
        this.amortizacion.numero_cuotas = this.amortizacion.detalle.length;
        this.amortizacion.empresa_id = this.ss.getData('empresa_id');
        this.amortizacion.usuario_id = this.ss.getData('usuario_id');
        this.compra.amortizacion = this.amortizacion;
    }


    isValidFormCuotas() {
        let totalCuotas = this.getTotalCuotasCredito();
        let ventaTotal = this.compra.total;
        let total_abonado = this.total_pago;
        if ((totalCuotas + total_abonado) != ventaTotal) {
            return false;
        }
        return true;
    }

    uploadXLM(event) {
        this.file = event.target.files[0];
        let fr = new FileReader();
        this.proveedor = new Proveedor();
        let promise = new Promise((resolve, reject) => {
            fr.onload = (e) => {
                let xml = fr.result;

                /*this.parser.parseString(xml, (err, result) => {
                    //this.xml=result;
                    if( err ) reject(err);
                    resolve(result);
                });*/


                xml2js.parseString(xml, (err, result) => {
                    if (err) reject(err);
                    //resolve(result);
                    this.comprobante = result.autorizacion.comprobante[0];
                });
                xml2js.parseString(this.comprobante, { ignoreAttrs: false, mergeAttrs: true }, function (err, result) {
                    if (err) reject(err);
                    resolve(result);
                });
            }
        });

        promise.then(
            result => {
                this.compras = [];
                this.proveedor.dni = result['factura']['infoTributaria'][0]['ruc'][0];
                this.proveedor.razon_social = result['factura']['infoTributaria'][0]['razonSocial'][0];
                this.proveedor.nombre_comercial = result['factura']['infoTributaria'][0]['nombreComercial'][0];
                //this.proveedor.correo = result['factura']['infoTributaria'][0]['campoAdicional'][2];
                this.proveedor.telefono = '0999999999';
                //this.proveedor.correo = "sas";
                this.proveedor.direccion = result['factura']['infoTributaria'][0]['dirMatriz'][0];
                //this.proveedor.nombre_comercial = result['factura']['infoLiquidacionCompra'][0]['razonSocialComprador'];
                this.compra.serie = result['factura']['infoTributaria'][0]['estab'][0];
                this.compra.punto_emision = result['factura']['infoTributaria'][0]['ptoEmi'][0];
                this.compra.secuencial = result['factura']['infoTributaria'][0]['secuencial'][0];
                this.compra.numero_autorizacion = result['factura']['infoTributaria'][0]['claveAcceso'][0];
                this.fecha_emision = moment(result['factura']['infoLiquidacionCompra'][0]['fechaEmision'][0], "DD/MM/YYYY");
                this.compra.fecha_emision = this.fecha_emision;
                let detalles = result['factura']['detalles'][0]['detalle'];

                detalles.forEach(detalle => {
                    let producto = new Producto();
                    let compra_detalle = new CompraDetalle();
                    compra_detalle.cantidad = detalle['cantidad'][0];
                    compra_detalle.precio_unitario = detalle['precioUnitario'][0];
                    compra_detalle.desc_valor = detalle['descuento'][0];
                    compra_detalle.producto.codigo = detalle['codigoPrincipal'][0];
                    compra_detalle.producto.nombre = detalle['descripcion'][0];
                    // compra_detalle.es_servicio = producto.es_servicio;
                    compra_detalle.tipo_producto_id = producto.tipo_producto_id;
                    compra_detalle.producto_id = producto.id;
                    compra_detalle.usuario_id = this.ss.getData('usuario_id');
                    compra_detalle.empresa_id = this.ss.getData('empresa_id');
                    compra_detalle.sucursal_id = this.ss.getData('sucursal_id');
                    this.comprasXML.push(compra_detalle);
                });

                //this.calcularCuotasCredito();
                this.permitirBotones = true;
            },
            err => {
                console.log(err);
            }
        );

        fr.readAsText(this.file, 'ISO-8859-4');
    }

    getProveedor() {
        this.loading = true;
        //this.permitirBotones = false;
        this.proveedorService.getByDni(this.proveedor.dni).subscribe(
            res => {
                this.loading = false;
                if (res.length <= 0) {
                    this.permitirBotones = false;
                } else {
                    this.proveedor = res[0];
                    if (this.proveedor.correo.trim().length) {
                        this.correos = this.proveedor.correo.split(',');
                    }
                    this.permitirBotones = true;
                }

            },
            err => {
                this.loading = false;
                //this.proveedor = new Proveedor();
            }
        );
    }

    onSubmitProveedor() {
        this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar el registro del proveedor?").then(
            res => {
                this.setValueEntityProveedor();
                this.loading = true;
                this.proveedorService.save(this.proveedor).subscribe(
                    res => {
                        this.loading = false;
                        this.msgSweet.showMessage('success-message', res.message);
                        this.permitirBotones = true;
                        //this.proveedor = new Proveedor();
                        //this.correos = [];
                    },
                    err => {
                        this.loading = false;
                        this.msgSweet.showMessage('error-message', err);
                    }
                );
            }
        );
    }

    setValueEntityProveedor() {
        this.proveedor.empresa_id = this.ss.getData("empresa_id");
        this.proveedor.usuario_id = this.ss.getData("usuario_id");
        //this.proveedor.correo = this.correos.toString();
        //this.proveedor.correo = this.correos.toString();
        this.proveedor.tipo_persona = "J";
        this.proveedor.tipo_identificacion_id = 1;
        this.proveedor.celular = this.proveedor.telefono;
        this.proveedor.nombre_comercial = this.proveedor.razon_social;
        this.proveedor.tipo_dni = "RUC";
    }


    getIfUsoLote() {
        return new Promise((resolve, reject) => {
            let if_uso_lote = 20;
            this.parametroService.getById(if_uso_lote).subscribe(
                res => {
                    this.if_uso_lote = (res.valor.toString().trim() === "1");
                    resolve();
                },
                err => {
                    this.if_uso_lote = false;
                    reject(err);
                }
            );
        });
    }

    onChangeFecha(event) {
        /*if(event < this.fecha_MesAnt){
            this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");
        }*/
    }

    openModalDetalle(template: TemplateRef<any>, compra_detalle: CompraDetalle) {
        this.detalle = compra_detalle.detalle;
        this.compra_detalle = compra_detalle;
        this.bsModalRef = this.modalService.show(template);
    }

    saveDetalle() {
        this.compra_detalle.detalle = this.detalle.toString().trim();
        this.detalle = "";
        this.bsModalRef.hide();
    }

    openModalLote(template: TemplateRef<any>, compra_detalle: CompraDetalle) {
        this.lote.codigo = compra_detalle.lote.codigo;
        this.lote.fecha_elaboracion = compra_detalle.lote.fecha_elaboracion;
        this.lote.fecha_expiracion = compra_detalle.lote.fecha_expiracion;
        this.compra_detalle = compra_detalle;
        this.bsModalRef = this.modalService.show(template);
    }

    saveLote() {
        this.compra_detalle.lote.codigo = this.lote.codigo;
        this.compra_detalle.lote.fecha_elaboracion = this.lote.fecha_elaboracion;
        this.compra_detalle.lote.fecha_expiracion = this.lote.fecha_expiracion;
        this.lote.codigo = "";
        this.lote.fecha_elaboracion = "";
        this.lote.fecha_expiracion = "";
        this.bsModalRef.hide();
    }

    isValidFormLote() {
        if (!this.lote.fecha_elaboracion && !this.lote.fecha_expiracion) {
            if (!this.lote.codigo) {
                return false;
            }
        }
        return true;
    }
    validErrorForm(campo) {
        return this.vl.validErrorForm(campo, this.myForm);
    }

    getNumeroComprobante() {
        if (!this.compra.tipo_comprobante_id) {
            this.compra.serie = "";
            this.compra.punto_emision = "";
            this.compra.secuencial = "";
            this.compra.numero_documento = "";
            return;
        }

        if (!this.caja.id) {
            this.compra.numero_documento = "";
            this.msgSweet.showMessage('error-message', "Seleccione la caja");
            return;
        }

        let caja = this.cajas.filter(x => x.id == this.caja.id)[0];

        this.loading = true;

        this.comprobanteService.getSecuencial(this.compra.tipo_comprobante_id, caja.id).subscribe(
            res => {
                this.loading = false;
                if (res.secuencial) {
                    this.compra.serie = caja.sucursal.establecimiento;
                    this.compra.punto_emision = caja.punto_emision;
                    this.compra.secuencial = res.secuencial;

                    this.compra.numero_documento = this.compra.serie + "-" + this.compra.punto_emision + "-" + this.compra.secuencial;
                } else {
                    this.compra.serie = "";
                    this.compra.punto_emision = "";
                    this.compra.secuencial = "";
                    this.compra.numero_documento = "";
                }
                // this.calcularFactura();
                // this.calcularCuotasCredito();
            },
            err => {
                this.loading = false;
                this.compra.serie = "";
                this.compra.punto_emision = "";
                this.compra.secuencial = "";
                this.compra.numero_documento = "";

                this.msgSweet.showMessage('error-message', err);
            }
        );
    }
    onChangeBodega(event, bodega_id) {
        this.bodegas_selected.push(bodega_id);

        if (this.compras.length > 0) {
            this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de cambiar de bodega? El detalle de la compra se perderá").then(
                res => {
                    if (res == "ok") {
                        this.compras = [];
                    } else {
                        this.compra.bodega_id = this.bodegas_selected[this.bodegas_selected.length - 2];
                        this.bodegas_selected.push(this.compra.bodega_id);
                    }
                },
                err => {
                    this.compra.bodega_id = this.bodegas_selected[this.bodegas_selected.length - 2];
                    this.bodegas_selected.push(this.compra.bodega_id);
                }
            );
        } else {
            this.compras = [];
        }
    }

    getBodegas() {
        return new Promise((resolve, reject) => {
            this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                res => {
                    if (!res.data.length) {
                        this.bodegas = [];
                    } else {
                        this.bodegas = res.data;
                        this.bodegas_selected.push(this.bodegas[0].id);
                    }
                    resolve();
                },
                err => {
                    this.bodegas = [];
                    reject(err);
                }
            );
        });
    }

    onValidDateFecha() {
        return this.validDateFecha = this.vl.validDate(this.fecha_emision.toString());
    }

    onSearchProveedor(event) {
        if (event.keyCode === 13) {
            if (this.proveedor.dni.toString().trim().length == 0) {
                this.proveedor = new Proveedor();
                return;
            } else {
                this.proveedorService.getByDni(this.proveedor.dni).subscribe(
                    res => {
                        this.loading = false;
                        if (res.length > 0) {
                            this.proveedor = res[0];
                        } else {
                            this.proveedor = new Proveedor();
                            this.openDialogProveedor();
                        }
                    },
                    err => {
                        this.loading = false;
                        this.openDialogProveedor();
                    }
                );
            }
        }
    }

    openDialogProveedor() {
        this.correos = [];
        const initialState = {};
        this.bsModalRef = this.modalService.show(ProveedorModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

        this.bsModalRef.content.sendProveedor.take(1).subscribe((value) => {
            this.sendObjectProveedor(value);
        });
    }
    sendObjectProveedor(event) {
        //obtencion del producto que envia el componente producto-modal
        this.proveedor = event;
        //  this.retencion = false;
        if (this.proveedor.correo.trim().length) {
            this.correos = this.proveedor.correo.split(',');
        }
    }
    onSearchServicio() {
        if (!this.compra.tipo_comprobante_id) {
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        const initialState = { numero_decimales: this.numero_decimales };
        this.bsModalRef = this.modalService.show(ServicioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

        this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
            this.sendObjectProducto(value);
        });
    }

    onSearchProducto() {
        if (!this.compra.tipo_comprobante_id) {
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        if (!this.compra.bodega_id) {
            this.msgSweet.showMessage('error-message', "Seleccione la bodega");
            return;
        }

        const initialState = { bodega_id: this.compra.bodega_id, numero_decimales: this.numero_decimales };
        this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

        this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
            this.sendObjectProducto(value);
        });
    }

    sendObjectProducto(event) {
        let compraDetalle = new CompraDetalle();

        let producto = event;
        let compra_detalle = new CompraDetalle();
        compra_detalle.cantidad = 1;
        // compra_detalle.producto = producto;
        // compra_detalle.es_servicio = producto.es_servicio;
        // compra_detalle.producto_id = producto.id;
        // compra_detalle.usuario_id = this.ss.getData('usuario_id');
        // compra_detalle.empresa_id = this.ss.getData('empresa_id');
        // compra_detalle.sucursal_id = this.ss.getData('sucursal_id');

        // this.compras.push(compra_detalle);
        // this.calcularCuotasCredito();

        // venta_detalle.cantidad_stock = producto.cantidad_stock;
        // venta_detalle.cantidad = (producto.cantidad?producto.cantidad:1);
        // compra_detalle.es_servicio = producto.es_servicio;
        compra_detalle.tipo_producto_id = producto.tipo_producto_id;
        compra_detalle.descripcion = producto.descripcion;
        compra_detalle.producto = producto.nombre;
        compra_detalle.codigo = producto.codigo;
        compra_detalle.unidad = producto.unidad;
        compra_detalle.producto_id = producto.id;
        compra_detalle.graba_iva = producto.graba_iva;
        compra_detalle.precio_unitario = 0;


        //compra_detalle.subtotal = compra_detalle.cantidad * compra_detalle.precio_unitario;
        compra_detalle.subtotal = this.utils.redondear((compra_detalle.cantidad * compra_detalle.precio_unitario), this.calculo_decimales);

        compra_detalle.total = compra_detalle.subtotal + compra_detalle.iva;
        compra_detalle.usuario_id = this.ss.getData('usuario_id');
        compra_detalle.empresa_id = this.ss.getData('empresa_id');
        compra_detalle.sucursal_id = this.ss.getData('sucursal_id');

        // this.ventasDetalle.push(venta_detalle);
        this.compras.push(compra_detalle);
        // this.recalcularFactura();
        // this.calcularCuotasCredito();
        this.recalcularFactura();
        this.calcularCuotasCredito();



    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/liquidacion-compra-add/liquidacion-compra-add.component.ts